export * from './declaracao-de-vizinhos';